export const minutesToMilliseconds = (time: number) => {
    // round to prevent floating point problems
    return Math.round(time * 60 * 1000);
};

export const getElapsedTime = (time1: number, time2: number) => {
    // round to prevent floating point problems
    return Math.round((time2 - time1) / 100) * 100;
};
